<script>
import DataLayer from '@services/data-layer/index'
import MixGridBlock from '@components/mix-grid-block'
import { shuffleArray } from '@utils/arrays'

const HOT_DROPS_FETCH_LIMIT = 10
const DESKTOP_BREAKPOINT = 1025
const DESKTOP_DISPLAY_LIMIT = 4
const MOBILE_DISPLAY_LIMIT = 4

export default {
    components: { MixGridBlock },
    data() {
        return {
            mixes: [],
            windowWidth: window.innerWidth,
        }
    },
    computed: {
        currentUserId() {
            return this.$store.state.auth.currentUser?.members_id?.id
        },
        skeletonCount() {
            return this.windowWidth >= DESKTOP_BREAKPOINT ? DESKTOP_DISPLAY_LIMIT : 4
        },
        displayedMixes() {
            if (this.windowWidth >= DESKTOP_BREAKPOINT) {
                return this.mixes.slice(0, DESKTOP_DISPLAY_LIMIT)
            }
            return this.mixes.slice(0, MOBILE_DISPLAY_LIMIT)
        },
    },
    mounted() {
        this.getRecommendedMixes()
        window.addEventListener('resize', this.onResize)
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.onResize)
    },
    methods: {
        async getRecommendedMixes() {
            if (!this.currentUserId) return

            const mixes = await DataLayer.mixes.getRecommended(this.currentUserId, HOT_DROPS_FETCH_LIMIT)
            this.mixes = shuffleArray(mixes.body)
        },
        onResize() {
            this.windowWidth = window.innerWidth
        },
    },
}
</script>

<template>
    <div>
        <BaseSection
            v-if="mixes.length"
            title="Hot Drops for you"
            subtitle="Mixes we think you'll dig"
        >
            <MixGridBlock :mixes="displayedMixes"/>
        </BaseSection>
        <BaseSection
            v-else
            title="Hot Drops for you"
            subtitle="Mixes we think you'll dig"
        >
            <div class="skeleton">
                <div
                    v-for="i in skeletonCount"
                    :key="i"
                    class="skeleton-tile"
                >
                    <div class="skeleton-cover" />
                    <BasePlaceholder
                        type="artist"
                        tag="div"
                        class="skeleton-title"
                    />
                    <BasePlaceholder
                        type="show"
                        tag="div"
                        class="skeleton-subtitle"
                    />
                </div>
            </div>
        </BaseSection>
    </div>
</template>

<style lang="scss" scoped>
@use '@design' as *;

.skeleton {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: $s-m;

    @include tablet {
        grid-template-columns: repeat(3, 1fr);
    }

    @include desktop {
        grid-template-columns: repeat(4, 1fr);
    }
}

.skeleton-cover {
    aspect-ratio: 1;
    background: currentColor;
    border-radius: 2px;
    opacity: 0.1;
}

.skeleton-title {
    margin-top: $size-grid-padding;
}

.skeleton-subtitle {
    margin-top: $s-xs;
}
</style>
